import React from "react";

const Logo = ({ size = 36 }) => (
  <svg width={size} height={size} viewBox="0 0 1024 1024" aria-hidden="true">
    <defs>
      <linearGradient id="meck-orange" gradientUnits="userSpaceOnUse" x1="0" y1="230" x2="0" y2="830">
        <stop offset="0" stopColor="#FFB347" />
        <stop offset="1" stopColor="#FF7410" />
      </linearGradient>
      <radialGradient id="meck-bg" gradientUnits="userSpaceOnUse" cx="512" cy="430" r="640">
        <stop offset="0" stopColor="#34343B" />
        <stop offset="1" stopColor="#0E0E10" />
      </radialGradient>
    </defs>
    <rect width="1024" height="1024" rx="228" fill="url(#meck-bg)" />
    <g transform="translate(512 512) skewX(-8) translate(-512 -512)">
      <path
        d="M232 760 L232 300 L512 600 L792 300 L792 760"
        fill="none"
        stroke="url(#meck-orange)"
        strokeWidth="130"
        strokeLinejoin="round"
        strokeLinecap="round"
      />
    </g>
  </svg>
);

export default Logo;
